import React, { useEffect, useState } from 'react';
import { Card, CardActions, CardContent, CardMedia, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { red } from '@material-ui/core/colors';
import DocumentField from '../../../components/DocumentField';
import { Field } from 'formik';
import filesEndpoint from '../../../api/services/filesEndpoint';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    width:'100%',
    maxWidth: 200,
  },
  media: {
    height: 0,
    paddingTop: '130%', // 3x4
    backgroundColor: '#f5f5f5'
  },
  noImage:{
    position: 'absolute',
    top: '35%',
    margin: 'auto',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: red[500],
  },
}));

function ConductorImage(props) {
  const classes = useStyles();

  const { values, setFieldValue, canEdit=true } = props;
  const [docInfo, setDocInfo] = useState({});
  const [uploading, setUpLoading] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    (async () => {
      if (values.idFileFoto && Object.keys(docInfo).length === 0) {
        const response = await filesEndpoint.getFileData(values.idFileFoto);
        if (response && response.status === 200 && response.data) {
          setDocInfo(response.data);
        }
      }
      setLoading(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[values.idFileFoto]);

  const processDoc = (docResult) => {
    setUpLoading(true);
    if (docResult.id) {
      const file = {
        id: docResult.id,
        fileName: docResult.name,
        viewLink: docResult.viewLink
      };
      setDocInfo(file);
      setFieldValue('idFileFoto', docResult.id);
    }
    setUpLoading(false);
  }

  const deleteFile = () => {
    setDocInfo({});
    setFieldValue('idFileFoto', '');
  }

  if(loading) return <></>

  return <>
    <Card className={classes.root}>
      {uploading ? <>
        <CardMedia className={classes.media} />
        <CardContent className={classes.noImage}><CircularProgress size={12} /></CardContent>
      </> : <>
        <CardMedia
          className={classes.media}
          image={docInfo.viewLink}
        />
        {!docInfo.viewLink &&
          <CardContent className={classes.noImage}>Sem Imagem</CardContent>
        }
      </>}
      <CardActions disableSpacing>
        <Field
          value={docInfo.id}
          required={false}
          name={`foto-condutor${values.cdCondutorSubstituto && '-' + values.cdCondutorSubstituto}`}
          label={''}
          id={docInfo.id || 'foto-condutor'}
          disabled={!canEdit}
          idFile={docInfo.id}
          onChangeFile={docResult => processDoc(docResult)}
          onDeleteFile={idFile => deleteFile(idFile)}
          uploading={uploading}
          setUpLoading={setUpLoading}
          component={DocumentField}
          onlyIcon={true}
        />
      </CardActions>
    </Card>
  </>;
}

export default ConductorImage;